module.exports = __webpack_public_path__ + "static/media/iconSepultacionCI.3d6c33ad.svg";